export const pathStringify = (str) => {
  return str.replace(/(-|^|%20)([^-]?)/g, function (_, prep, letter) {
    return (prep && ' ') + letter.toUpperCase()
  })
}
